import { useLocation } from "react-router"

export const useEmbedded = () => {
  const { search, pathname } = useLocation()
  const params = new URLSearchParams(search)
  const embedded = !!params.get("embed") && pathname === "/calendar"
  return {
    embedded,
  }
}
